import { ArrowLeft } from "lucide-react";
import {
  Page,
  HeaderSticky,
  HeaderInner,
  HeaderLeft,
  TabNavSticky,
  TabNavInner,
  TabNav,
  TabButton,
  Content,
  ContentCol,
  Card,
  CardHeader,
  CardHeaderLeft,
  CardTitleWrap,
  CardTitle,
  ConfigGrid,
  FieldCell,
  FieldLabelDiv,
  ViewValueRow,
  PricingCardHeader,
  PricingCardHeaderLeft,
  PricingIconWrap,
  PricingTitle,
  TableWrap,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  Td,
} from "../../../pages/PlanosDetail/styles";
import { SkeletonBlock, SkeletonCircle, SkeletonBadge, SkeletonTableRow } from "./styles";

export default function PlanosDetailSkeleton() {
  return (
    <Page>
      <HeaderSticky>
        <HeaderInner>
          <HeaderLeft>
            <div className="voltar-container" style={{ pointerEvents: "none" }} aria-hidden>
              <ArrowLeft size={20} color="#9ca3af" />
              <SkeletonBlock width="50px" height="16px" />
            </div>
            <div className="divider" />
            <h1 style={{ margin: 0 }}>
              <SkeletonBlock width="220px" height="32px" />
            </h1>
          </HeaderLeft>
        </HeaderInner>
      </HeaderSticky>

      <TabNavSticky>
        <TabNavInner>
          <TabNav>
            <TabButton type="button" disabled $active={true}>
              Principal
            </TabButton>
            <TabButton type="button" disabled $active={false}>
              Histórico
            </TabButton>
          </TabNav>
        </TabNavInner>
      </TabNavSticky>

      <Content>
        <ContentCol>
          <Card>
            <CardHeader>
              <CardHeaderLeft>
                <SkeletonCircle size="20px" />
                <CardTitleWrap>
                  <CardTitle as="div" style={{ margin: 0, minWidth: 200 }}>
                    <span className="card-title-text"><SkeletonBlock width="280px" height="22px" /></span>
                    <SkeletonBadge />
                  </CardTitle>
                </CardTitleWrap>
              </CardHeaderLeft>
            </CardHeader>
            <ConfigGrid>
              {[1, 2, 3, 4, 5].map((i) => (
                <FieldCell key={i}>
                  <FieldLabelDiv as="div">
                    <SkeletonBlock width="70%" height="11px" />
                  </FieldLabelDiv>
                  <ViewValueRow>
                    <SkeletonBlock width="60%" height="18px" />
                  </ViewValueRow>
                </FieldCell>
              ))}
            </ConfigGrid>
          </Card>

          <Card>
            <PricingCardHeader>
              <PricingCardHeaderLeft>
                <PricingIconWrap as="div">
                  <SkeletonCircle size="18px" />
                </PricingIconWrap>
                <PricingTitle as="div" style={{ margin: 0 }}>
                  <SkeletonBlock width="200px" height="22px" />
                </PricingTitle>
              </PricingCardHeaderLeft>
            </PricingCardHeader>
            <TableWrap>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Serviço</Th>
                    <Th className="center">Modalidade</Th>
                    <Th>Profissional</Th>
                    <Th className="center">Créditos</Th>
                    <Th className="center">Valor/Crédito</Th>
                    <Th className="right">Valor Total</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <Tr key={i}>
                      <Td><SkeletonBlock width="80%" height="14px" /></Td>
                      <Td className="center"><SkeletonBlock width="60px" height="20px" style={{ margin: "0 auto" }} /></Td>
                      <Td><SkeletonBlock width="70%" height="14px" /></Td>
                      <Td className="center"><SkeletonBlock width="40px" height="14px" style={{ margin: "0 auto" }} /></Td>
                      <Td className="center"><SkeletonBlock width="70px" height="14px" style={{ margin: "0 auto" }} /></Td>
                      <Td className="right"><SkeletonBlock width="80px" height="14px" style={{ marginLeft: "auto" }} /></Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableWrap>
          </Card>
        </ContentCol>
      </Content>
    </Page>
  );
}
